import React from "react";
import { Container } from "react-bootstrap";
import { Navbar, Nav } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";

const Footer = () => {
  return (
    <Navbar
      style={{ backgroundColor: "#e3f2fd" }}
      bg="light"
      data-bs-theme="light"
      fixed="bottom"
    >
      <Container className="justify-content-center">
        <Nav>
          <Nav.Link
            href="https://mamialex.ru/"
            className="text-dark fw-bold"
          >
            © {new Date().getFullYear()} Mami Alexander - All rights reserved.
          </Nav.Link>
        </Nav>
      </Container>
    </Navbar>
  );
};

export default Footer;